const messages = {
    availPoints: "Verfügbare Punkte",
    awaitingPoints: "Ausstehende Punkte",
  board: {
    title: "Dashboard",
    title2: "Performance-Animation {year}",
    headline1: "Ihre Aktionen und Punkte auf einen Blick",
    headline2: "Sammeln Sie Punkte für Ihre Reifenkäufe.",
    pointsBalanceToDate: "PUNKTESALDO ZUM AKTUELLEN DATUM",
    availPoints: "Verfügbare Punkte",
    awaitingPoints: "Ausstehende Punkte",
    yourRealisation: "IHRE ERFOLGE",
    yourEngagement: "Ihr jährliches Engagement: <b>{tyres} Reifen</b>",
    yourPoints: "IHRE PUNKTE",
    yourRetailPurchase: "IHRE EINZELHANDELSKÄUFE",
    yourRetailPurchaseCCS: "IHR EINZELHANDELSUMSATZ",
    pointsByPurchase: "Punkte aus Ihren Einkäufen",
    pointsByBoosters: "Punkte durch Booster",
    pointsByBSPurchase: "Punkte aus Ihren Bridgestone-Käufen",
    pointsByBSPurchaseCCS:
      "Punkte aus Ihrem Bridgestone-Reifenverkauf",
    remaining: "Verbleibende Reifen",
    yourGoal: "Fortschritt zum Ziel",
    unit: "Reifen",
    buttons: {
      learnMore: "Mehr über Ihre Punkte erfahren",
      learnMoreAboutMechanism: "Mehr über den Mechanismus erfahren",
    },
    charts: {
      byBrand: "Nach Marke",
      bySize: "Nach<br/>Felgengröße",
    },
    exploreResults: "Entdecken Sie Ihre Ergebnisse",
    tyreLimitInfo:
      "Für jeden Booster-Kampagnenzeitraum ist ein Mindestausverkaufsvolumen von 50 Bridgestone- und/oder Firestone-Reifen erforderlich",
  },
  charts: {
    byBrand: "Nach Marke",
    bySize: "nach Felgengröße",
  },

  dashboard: {
    dashboardTitle: "Ihre Vorteile",
    dashboardBox: {
      title: "Punktestand",
      description: "Ihr aktueller Marketing-Punktestand",
      availPoints: "Verfügbare Punkte",
      awaitingPoints: "Ausstehende Punkte",
      lastUpdate: "Letzte Aktualisierung",
      button: "Mehr erfahren",
      points: "Punkte",
    },
  },
  soldTyres: "VERKAUFTE REIFEN",
  receivedPoints: "VERDIENTE PUNKTE",
  boosterCCS: {
    personalInfo: "Persönliche Angaben",
    csNumberTitle: "Bitte geben Sie die teilnehmende(n) Kontonummer(n) an",
    tyresTitle: "Bitte geben Sie die Anzahl der verkauften Reifen an",
    minTyresInfo:
      "Es sind mindestens {tyres} Bridgestone/Firestone-Reifen erforderlich. Die Entschädigung gilt nur für Bridgestone-Reifen.",
    tyresAmount: "Anzahl der Reifen",
    filesTitle: "Laden Sie bitte Ihren Verkaufsnachweis hoch",
    filesDescription:
      "Hinweis: Berücksichtigt werden nur Verkäufe mit Angabe der Reifen-Felgengröße.",
    addAnotherFile: "Weiteres Dokument hinzufügen",
    file: "Dokument hochladen",
    formatInfo:
      "Zulässige Dateiformate: xlsx, jpeg und pdf. Maximale Dateigröße: 8 MB",
    confrimationMessage:
      "<b>Vielen Dank für Ihre Teilnahme!</b> <br/>Ihre Anfrage ist eingegangen und wurde zur Prüfung an die Bridgestone-Teams weitergeleitet.<br/>Sie erhalten eine E-Mail mit dem Ergebnis Ihrer Teilnahme an Booster CCS.<br/>Bis bald bei Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Punkte teilen",
    forShare: "Punkte, die Sie teilen",
    title: "Titel",
  },
  notFoundFile: "Nichts ausgewählt",
  chooseFile: "Datei auswählen",
};
export default {
  messages,
};
